<app-modal-frame
  [headerText]="CONST.HEADER"
  [hasHeaderCloseButton]="false"
  (emitExit)="dialogRef.close()"
>
  <div class="end-scan-modal">
    <div class="message">
      {{ message }}
    </div>
    <ion-row class="ion-justify-content-end">
      <ion-button class="ok-btn" (click)="ok()">
        {{ CONST.OK }}
      </ion-button>
    </ion-row>
  </div>
</app-modal-frame>
